import {
    RequestKeys,
} from 'app/hooks/useRequest'

import ChangeHistory from 'app/shared-components/ChangeHistory'

import config from 'app/requests/ContractBasis/LaneGroup/LaneGroup.requests'

import {
    getLaneGroupLaneChangeHistoryColumns,
    getLaneGroupLaneFeesChangeHistoryColumns,
} from './LaneGroupChangeHistory.columns'
import useStyles from './LaneGroupChangeHistory.style'

const LaneGroupChangeHistory = ({
    id,
}: { id: number }) => {
    const {
        classes,
    } = useStyles()

    return (
        <>
            <div
                key="LaneGroupChangeHistory"
                className={classes.container}
            >
                <ChangeHistory
                    id={id}
                    requestKey={RequestKeys.getLaneGroupModifications}
                    config={config.modifications}
                    configName="LaneGroupChangeHistoryTable"
                    name="LaneGroupChangeHistory"
                    labelPrefixForChangedColumn={['LaneGroup']}
                    title="Lane Group Change Summary"
                />
            </div>
            <div
                key="LaneGroupLaneChangeHistory"
                className={classes.container}
            >
                <ChangeHistory
                    id={id}
                    requestKey={RequestKeys.getLaneGroupLaneModifications}
                    config={config.laneModifications}
                    configName="LaneGroupLaneChangeHistoryTable"
                    name="LaneGroupLaneChangeHistory"
                    labelPrefixForChangedColumn={['Lane']}
                    title="Lane Change Summary"
                    columns={getLaneGroupLaneChangeHistoryColumns(['Lane'])}
                />
            </div>
            <div
                key="LaneGroupLaneFeesChangeHistory"
                className={classes.container}
            >
                <ChangeHistory
                    id={id}
                    requestKey={RequestKeys.getLaneGroupLaneFeesModifications}
                    config={config.laneFeesModifications}
                    configName="LaneGroupLaneFeesChangeHistoryTable"
                    name="LaneGroupLaneFeesChangeHistory"
                    labelPrefixForChangedColumn={['LaneFees']}
                    title="Lane Fees Change Summary"
                    columns={getLaneGroupLaneFeesChangeHistoryColumns(['LaneFees'])}
                />
            </div>
        </>
    )
}

export default LaneGroupChangeHistory
